import type { ComponentType } from "react";
import { Headset, UsersRound } from "lucide-react";
import { ROUTES } from "../../../../components/shared/constant";
import { SkyEmployeeMark } from "@/views/employee/EmployeeBrandMarks";
import type { DefaultLanding } from "@/store/slices/userPreferencesSlice";

/** The products the shell hosts. Same identifiers as the stored preference. */
export type ProductValue = DefaultLanding;

export interface ProductOption {
  value: ProductValue;
  /** Human label — used by the header switcher and the Settings page alike. */
  text: string;
  /**
   * Lucide glyph for products without their own artwork, or a brand mark
   * component. Both are driven by `className` alone, so callers size them the
   * same way regardless of which they get.
   */
  Icon: ComponentType<{ className?: string }>;
  /**
   * Tailwind classes for the tinted square behind the icon. Products with real
   * brand artwork use a neutral surface so the artwork supplies the colour.
   */
  iconClass: string;
  /** Where this product opens. */
  route: string;
}

export const PRODUCT_OPTIONS: ProductOption[] = [
  {
    value: "service-desk",
    text: "Service Desk",
    Icon: Headset,
    iconClass: "bg-blue-50 text-blue-600 dark:bg-blue-500/15 dark:text-blue-400",
    route: ROUTES.HOME,
  },
  {
    value: "workforce",
    text: "Workforce Lifecycle",
    Icon: UsersRound,
    iconClass: "bg-amber-50 text-amber-600 dark:bg-amber-500/15 dark:text-amber-400",
    route: ROUTES.WORKFORCE,
  },
  {
    value: "employee",
    text: "Employee Experience",
    Icon: SkyEmployeeMark,
    // Neutral, unlike the two lucide-glyph products: the mark carries its own
    // amber, and a tinted square behind it muddies the brand colour.
    iconClass: "bg-gray-50 dark:bg-white/10",
    route: ROUTES.EMPLOYEE,
  },
];
